import { Category, FilterBy, Flatten, makeDefinition, SecondLayerKeys } from "./Category"
import { IndustryTypes } from "./IndustryTypes"

export namespace PriceFieldCategories {

    // Will enforce the shape while allowing keys and values to slip through
    function enforceType<T extends {
        [P in keyof IndustryTypes.IndustryTypes]: {
            [key: string]: Omit<Category<T[P]>, 'id'>
        }
    }>(val: T) {
        return val
    }

    /*
    type s = {
        [P in keyof typeof Grouped as keyof typeof Grouped[P]]: keyof typeof Grouped[P]
    }
    type y = typeof Grouped[keyof typeof Grouped]
    type k<T extends keyof typeof Grouped> = typeof Grouped[T] & K<Exclude<keyof typeof Grouped, T>>
    type maga = keyof typeof Grouped

    type h = { [K in keyof typeof Grouped]: typeof Grouped[K][keyof typeof Grouped[K]] }
    type g = {
        [K in 'a' | 'b' as K]: K
    }

    export type Flatten<T> = {
        [O in keyof T as keyof T[O]]: T[O][keyof T[O]]
    }

    // type p = {[O in keyof (typeof Grouped) as keyof (typeof Grouped)[O]]: (typeof Grouped)[O][keyof (typeof Grouped)[O]]}

    type p = {
        [O in keyof (typeof Grouped) as keyof (typeof Grouped)[O]]: (typeof Grouped)[O][keyof (typeof Grouped)[O]] }


    type å = typeof Grouped[keyof typeof Grouped]

    type u = {
        [K in keyof typeof Grouped as keyof typeof Grouped[Extract<keyof typeof Grouped, K>]]: K
    }


    function ms<T>(v: { [key: string]: T }): T {
        return {} as T
    }

    type pp<T> = T extends { [key: string]: {} } ? T & pp<T[keyof T]> : T
    type o = pp<typeof Grouped>
    type v = {
        [K in keyof (typeof Grouped[keyof typeof Grouped]) as keyof typeof Grouped]: K
    }

    */


    export const { Flat, FlatList, FlatEnum, FlatEnumList, Grouped, GroupedList, GroupedEnum, GroupedEnumList } = makeDefinition(enforceType({
        [IndustryTypes.FlatEnum.PLUMBING]: {
            DRAIN: {
                name: 'Avløp',
                description: 'Avløp og vannlås',
            },
            DISTRIBUTION_CABINET: {
                name: 'Fordelerskap',
                description: 'Fordelerskap',
            },
            SUPPLY: {
                name: 'Tilførsel',
                description: 'Tilførsel',
            },
            HEATING: {
                name: 'Varme',
                description: 'Varme',
            },
            MIXER_TAP: {
                name: 'Blandebatteri',
                description: 'Blandebatteri',
            },
            WC: {
                name: 'WC',
                description: 'WC og deler',
            },
            OUTSIE: {
                name: 'Utvendig',
                description: 'Utenfor huset',
            },
            WATER_HEATER: {
                name: 'Vvb',
                description: 'Vvb og reservedeler',
            },
            GARNISH: {
                name: 'Garnityr',
                description: 'Garnityr',
            },
            CISTERNS: {
                name: 'Sisterne',
                description: 'Sisterne',
            },
            OTHER: {
                name: 'Annet',
                description: 'Annet',
            },
        },
        [IndustryTypes.FlatEnum.GARDENING]: {
            DIRT: {
                name: 'Jord',
                description: 'Jord',
            },
            FERTELIZER: {
                name: 'Gjødsel',
                description: 'Gjødsel',
            },
            PLANTS: {
                name: 'Planter',
                description: 'Planter',
            },
        },
        [IndustryTypes.FlatEnum.CARPENTRY]: {
            PLANKS: {
                name: 'Planker',
                description: 'Planker',
            },
            NAILS: {
                name: 'Spiker',
                description: 'Spiker',
            },
            WALLPAPER: {
                name: 'Tapet',
                description: 'Tapet',
            },
        },
        [IndustryTypes.FlatEnum.ELECTRICAL]: {
            CABLES: {
                name: 'Kabler',
                description: 'Kabler, ledere ...',
            },
            OPEN_INSTALLATION: {
                name: 'Åpen installasjon',
                description: 'Kabler, ledere, koblingsbokser ...',
            },
            FASTENERS: {
                name: 'Festemateriell',
                description: 'Kabel klammer, trekkerør, kabelkanaler ...',
            },
            SUPPLY: {
                name: 'Tilførsel',
                description: 'Sikringsskap, trafoer, kurser, sikringer ...',
            },
            SOCKETS: {
                name: 'Stikkontakter',
                description: 'Stikkontakter ol. for inne og utebruk',
            },
            SWITCHES: {
                name: 'Brytere',
                description: 'Lysbrytere, timere, dimmere ...',
            },
            LIGHTING: {
                name: 'Belysning',
                description: 'Belysningsutstyr for inne og uteområder',
            },
            OUTSIDE: {
                name: 'Uteområde',
                description: 'Utelamper, utekontakter, jordkabler ...',
            },
            SMARTHOME: {
                name: 'Smarthus',
                description: 'Komponenter for smarthusløsninger',
            },
            DOCUMENTATION: {
                name: 'Dokumentasjon',
                description: 'Dokumentasjonskostnader',
            },
            WORK_TIME: {
                name: 'Arbeidstimer',
                description: 'Timesbetaling ol.',
            },
            HEATING: {
                name: 'Varme',
                description: 'Varmeelementer ol.',
            },
            APPLIANCES: {
                name: 'Hvitevarer',
                description: 'Tørketromler, oppvasksmaskiner osv.',
            },
            WET_ROOM: {
                name: 'Våtrom',
                description: 'Komponenter som kan brukes i våtrom',
            },
            OTHER: {
                name: 'Annet',
                description: 'Brukes skjeldent for det som ikke passer inn andre steder (vurder å be om nye kategorier i stede for å bruke denne)',
            },
        },
    }))

    export type TypesFor<T extends IndustryTypes.IndustryType> = SecondLayerKeys<FilterBy<typeof GroupedEnum, T>>
    export type TypeFor<T extends IndustryTypes.IndustryType> = Flatten<typeof Grouped, T>[keyof Flatten<typeof Grouped, T>]
    export type Types = typeof FlatEnum
    export type Type = keyof typeof FlatEnum

    export function industryTypesFor(categories: Type[]): IndustryTypes.IndustryType[] {
        return IndustryTypes.FlatEnumList
            .filter(industryType => GroupedEnumList[industryType].some(category => categories.includes(category)))
    }
}
